<template>
	<div>
		<transition name="fade">
			<div v-if="loading" id="preloader">
				<div id="status"></div>
			</div>
		</transition>
		<header>
			<nav class="container" style='padding-bottom: 0;'>
				<div class="row">
					<div class="col-xs-12 col-sm-9 col-md-7 ">
							<img
							class="img-responsive logo-head"
							src="@/assets/images/eas-head.svg"
							alt="EAS">
							<div class="home-page-title" style="margin-left:0;">
							Reset your <br>password
							</div>
					</div>
				</div>
			</nav>
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-5">
						<div class="intro-text-white">
							Enter your new password.
						</div>
					</div>
				</div>
				<div class="row">

					<div class="col-xs-12 col-sm12 col-md-4">
						<div class="form-group">
							<label class="form-label sr-only" for="inputPassword">Password</label>
							<input
								v-model="password"
								class="form-control"
								name="password"
								type="password"
								placeholder="Password"
								required
							>
							<br/>
							<label class="form-label sr-only" for="confirmPassword">Confirm Password</label>
							<input
								v-model="confirmPassword"
								class="form-control"
								name="confirmPassword"
								type="password"
								placeholder="Confirm password"
								required
							>
						</div>
						<div class="left-center-xs">
							<b-btn class="btn btn-md btn-success" type="submit" @click="reset">
								Reset password
							</b-btn>
							<div>
								<router-link class="btn btn-clear" to="/login" tag="a">Back to login</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
<footer>
		<div class="container">
			<div class="row">
				<div class="col-xs-12 logo-container-foot">
					<a href="/">
					<img class="img-responsive logo-foot" src="@/assets/images/eas-head.svg" alt="EAS Strategies">
					</a>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 text-center">
					<p>
												<a href="https://eas-strategies.com/" target="_blank">EAS Strategies</a>
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="https://eas-strategies.com/privacy/" target="_blank">Privacy policy</a>
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="https://eas-strategies.com/disclaimer/" target="_blank">Disclaimer</a>
						<br />
						<br />
						©  {{currentYear}}  EAS Strategies Ltd.
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="http://www.bubblegate.co.uk" target="_blank">Built by Bubblegate</a>
					</p>
				</div>
			</div>
		</div>
	</footer>
	</div>
</template>

<style lang="less">
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
import moment from 'moment';
import { Notification } from 'uiv';
import jwt from 'jsonwebtoken';

export default {
	created() {
		this.runLoader();
	},
	data() {
		return {
			password: null,
			confirmPassword: null,
			loading: false
		};
	},
	validations: {
		password: { required, minLength: minLength(6) },
		confirmPassword: { required, sameAsPassword: sameAs('password') }
	},
	methods: {
		async reset() {
			if (this.$v.$invalid) {
				Notification.notify({
					type: 'warning',
					title: 'Could not reset password.',
					content: 'Password requirements not met.',
					duration: 3000
				});
			} else {
				try {
					const token = jwt.decode(this.$route.params.token);
					await this.$axios.patch(`/reset-password/${token.sub}`, {
						token: this.$route.params.token,
						password: this.password
					});
					this.$router.push({ path: '/login' });
					Notification.notify({
						type: 'info',
						title: 'Password successfully reset.',
						duration: 10000
					});
				} catch (e) {
					Notification.notify({
						type: 'warning',
						title: 'Could not reset password.',
						content: e.response ? e.response.data.message : 'Unexpected error.',
						duration: 3000
					});
				}
			}
		},
		runLoader() {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		}
	},
	computed: {
		currentYear() {
			return moment().format('YYYY');
		}
	}
};
</script>
